<template>
  <b-modal
    ref="openModal"
    class="localizationModal"
    scrollable
    size="xl"
    :title="`${this.$t('tracking.cargoExpense.edit')} #${this.id}`"
    @show="onModalShow"
    @hide="onModalHide"
  >
    <b-row>
      <b-col sm="12" md="6" lg="6">
        <success-fade-alert ref="alert" :msg="alert.success" />
        <fade-alert-danger ref="danger" :msg="alert.error" />

        <div>
          <!-- {{model.permissions}} -->
          <div v-if="model.permissions != 0">
            <div v-if="model.permissions == 1">
              <cargo-expense-crud-data
                ref="crud"
                :model="model"
                :modelstate="modelstate"
                :readonly="canEdit"
                :cargoExpenseTypeId="model.cargoExpenseTypeId"
                class="mb-4"
              >
              </cargo-expense-crud-data>
              <custom-value
                ref="customValue"
                :items.sync="model.customValues"
                :occurrenceId="model.cargoExpenseOccurrenceId"
                :id="id"
                :readonly="!canEdit"
                :modelstate="modelstate"
                :permissions="model.permissions"
                class="customValue"
              >
              </custom-value>
              <b-button class="button" @click="save" :disabled="canSubmit">
                {{ $t("geral.save") }}
              </b-button>
            </div>

            <div v-else-if="model.permissions == 2">
              <cargo-expense-crud-data
                ref="crud"
                :model="model"
                :modelstate="modelstate"
                :readonly="true"
                :cargoExpenseTypeId="model.cargoExpenseTypeId"
                :permissions="model.permissions"
                class="mb-4"
              >
              </cargo-expense-crud-data>
              <custom-value
                ref="customValue"
                :items.sync="model.customValues"
                :occurrenceId="model.cargoExpenseOccurrenceId"
                :id="id"
                :readonly="true"
                :modelstate="modelstate"
                class="customValue"
              >
              </custom-value>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <div v-if="notHaveAccess == true">
      <div class="mt-5">
        <cargo-expense-story
          ref="cargoExpenseStory"
          :cargo-expense-id="getCargoExpenseId"
        >
        </cargo-expense-story>
      </div>
    </div>
    <template #modal-footer="{ cancel }">
      <div class="right">
        <b-button variant="green" @click="save($event)" :disabled="canSubmit">
         {{ $t("geral.save") }}
        </b-button>
        <b-button class="ml-2" variant="danger" @click="cancel()">
          {{ $t("geral.cancel") }}
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";
import CargoExpenseCrudData from "@/components_rms/trackingShippingCompany/cargoExpense/CargoExpenseCrudData.vue";
import CargoExpenseStory from "@/components_rms/trackingShippingCompany/cargoExpense/CargoExpenseStory.vue";
import CustomValue from "@/components_rms/trackingShippingCompany/cargoExpense/CustomValue.vue";

export default {
  name: "CargoExpenseKanbanEdit",
  components: {
    FadeAlertDanger,
    SuccessFadeAlert,
    CargoExpenseCrudData,
    CargoExpenseStory,
    CustomValue,
  },
  props: {
    id: String,
    companyId: String,
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Registro alterado com sucesso",
      },
      submitted: false,
      modelstate: {},
      model: {
        adicionalInformation: "",
        branchName: "",
        cargoExpenseId: 0,
        cargoId: 0,
        cargoExpenseTypeId: 0,
        cargoExpenseTypeDescription: "",
        clientName: "",
        driverName: "",
        value: 0.0,
        responsability: 1,
        priority: 1,
        permissions: 0,
        transportNumber: "",
      },
      editFiled: false,
    };
  },
  computed: {
    canEdit() {
      if (this.model.permissions == 2) return false;
      if (this.model.permissions == 1) return true;
      if (!this.model) return false;
      if (!this.model.cargoActive) return true;
      if (this.model.status == 13) return false;

      return true;
    },
    canSubmit() {
      if (this.submitted) return true;
      if (!this.canEdit) return true;
      return false;
    },
    getCargoExpenseId() {
      if (!this.model) return 0;
      return this.model.cargoExpenseId;
    },
    getUrlCargoList() {
      if (this.companyId) {
        return `/v1/cargoExpense/get/${this.id}/${this.companyId}`;
      }
      return `/v1/cargoExpense/get/${this.id}`;
    },
    getPermission() {
      if (this.model.permissions == 2) return true;
      return false;
    },
    notHaveAccess() {
      if (this.model.permissions == 0) return false;
      return true;
    },
  },
  methods: {
    async loadData() {
      this.$api
        .get(this.getUrlCargoList)
        .then(async (response) => {
          let model = response.data;

          if (model.attachments.length > 0) {
            model.attachments.forEach(async (attachment) => {
              // console.log(attachment.content);
              const image = await this.loadImg(
                attachment.cargoExpenseAttachmentId
              );
              // console.log(image);
              if (image) attachment.content = image;
              else attachment.content = "";
            });
          }
          this.model = model;
          // console.log(model);
          // console.log("ok");
          // console.log(this.model);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            if (error.response) {
              if (error.response.status == 400) {
                this.modelstate = error.response.data.errors;
              }
            }
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
    async loadImg(attachmentId) {
      if (attachmentId == 0) return;
      let image = "";
      await this.$api
        .request({
          url: `${this.$store.state.urlTracking}/v1/cargoExpense/attachmentImage/${attachmentId}`,
          method: "GET",
          responseType: "arraybuffer", //important
        })
        .then((response) => {
          image = window.URL.createObjectURL(
            new Blob([response.data], {
              type: response.headers["content-type"],
            })
          );
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response.data.errors);
          if (error.response.status == 400) {
            console.log(error.response.data.errors);
          }
        });
      return image;
    },
    save() {
      try {
        this.submitted = true;
        // console.log(this.model);
        this.$api
          .post(
            "/v1/cargoExpense/edit/" + this.model.cargoExpenseId.toString(),
            this.model
          )
          .then((response) => {
            this.loadData();
            this.$forceUpdate();
            this.$refs.alert.show();
            this.modelstate = {};
            this.submitted = false;
            this.$emit("confirmEdit");
            this.hide();
          })
          .catch((error) => {
            this.submitted = false;
            this.modelstate = {};

            if (error.response) {
              if (error.response.status == 400) {
                this.modelstate = error.response.data.errors;
                this.alert.error = error.message;
                this.$refs.danger.show();
              } else if (error.response.status == 500) {
                this.alert.error = error.response.data;
                this.$refs.danger.show();
              } else {
                this.alert.error = error.message;
                this.$refs.danger.show();
              }
            } else {
              this.alert.error = error.message;
              this.$refs.danger.show();
            }
          });
      } catch (e) {
        this.submitted = false;
        this.modelstate = {};
        this.alert.error = e.message;
        this.$refs.danger.show();
      }
    },
    show() {
      this.$refs.openModal.show();
    },
    hide() {
      this.$refs.openModal.hide();
    },
    onModalShow() {
      this.modelstate = {}; 
      this.loadData();
      if (this.model.permissions == 2) this.editField = true;
      if (this.model.permissions == 1) this.editField = false;
    },
    onModalHide() {

    },
  },
  watch: {
    stateId() {
      this.loadData();
    },
  },
};
</script>
